var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.75C5.175 18.75 1.25 14.825 1.25 10C1.25 5.175 5.175 1.25 10 1.25C14.825 1.25 18.75 5.175 18.75 10C18.75 14.825 14.825 18.75 10 18.75ZM10 2.5C5.8625 2.5 2.5 5.8625 2.5 10C2.5 14.1375 5.8625 17.5 10 17.5C14.1375 17.5 17.5 14.1375 17.5 10C17.5 5.8625 14.1375 2.5 10 2.5ZM10 5.625C8.6125 5.625 7.5 6.7375 7.5 8.125C7.5 8.47018 7.77982 8.75 8.125 8.75C8.47018 8.75 8.75 8.47018 8.75 8.125C8.75 7.4375 9.3125 6.875 10 6.875C10.6875 6.875 11.25 7.4375 11.25 8.125C11.25 8.67498 10.887 8.95394 10.4805 9.26639C9.96303 9.66406 9.375 10.116 9.375 11.25C9.375 11.5952 9.65482 11.875 10 11.875C10.3452 11.875 10.625 11.5952 10.625 11.25C10.625 10.5692 11.0684 10.1811 11.5239 9.78224C12.0052 9.36091 12.5 8.92769 12.5 8.125C12.5 6.7375 11.3875 5.625 10 5.625ZM10.775 13.75C10.775 14.178 10.428 14.525 9.99999 14.525C9.57197 14.525 9.22499 14.178 9.22499 13.75C9.22499 13.322 9.57197 12.975 9.99999 12.975C10.428 12.975 10.775 13.322 10.775 13.75Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.c8849d37cfa496b400cce683f7cf4115.svg";
export { ForwardRef as ReactComponent };